import React, { Component } from "react";
import Switch from "react-input-switch";
import { Col } from "react-bootstrap";

class ToggleSwitch extends Component {
  constructor(props) {
    super(props);
    this.state = { switched: 0};
  }

  toggleSwitch = () => {
    if (this.state.switched) {
      this.setState({
        switched: 0,
        typeSelected: null
      });
      this.props.switchStatusPFunc(false);
    } else {
      this.setState({
        switched: 1,
        typeSelected: "webcam"
      });
      this.props.switchStatusPFunc(true);
    }
  };

  componentWillReceiveProps (nextProps) {
    if(nextProps.onOff) {
      this.setState({
        switched: 1
      })
    } else {
      this.setState({
        switched: 0
      })
    }
  }

  render() {
    let status;
    if (this.state.switched)
      status = <p style={{ fontSize: "8px", color: "#C2C0BD" }}>ON</p>;
    else status = <p style={{ fontSize: "8px", color: "#C2C0BD" }}>OFF</p>;
    return (
      <div>
        <Col xs={8} style={{ display: "flex", alignItems: "center" }}>
          <Col xs={2} style={{ paddingRight: "8px", paddingLeft: "0px" }}>
            <div style={{ fontSize: "12px", color: "#C2C0BD" }}>input</div>
          </Col>
          <Col xs={3} style={{ paddingRight: "0px", paddingTop: "3px" }}>
            <Switch
              value={this.state.switched}
              onChange={this.toggleSwitch}
              styles={{
                track: {
                  backgroundColor: "#2E3A53"
                },
                trackChecked: {
                  backgroundColor: "#2E3A53"
                },
                button: {
                  backgroundColor: "#C2C0BD"
                },
                buttonChecked: {
                  backgroundColor: "#17D9AA"
                }
              }}
              className="iBorder"
            />
          </Col>
          <Col
            xs={2}
            style={{
              paddingLeft: "8px",
              paddingTop: "3px"
            }}
          >
            {status}
          </Col>
        </Col>
      </div>
    );
  }
}

export default ToggleSwitch;
